import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { cmsApi } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class InvestmentPlanDataService {


  constructor(private http: HttpClient) { }

  // getMaintain
  getWebServiceInflation() {
    let URL = cmsApi + '/getInflation'
    let body = {}
    return this.http.post(URL, body)
  }

  getWebserviceProvident() {
    let URL = cmsApi + '/getProvident'
    let body = {}
    return this.http.post(URL, body)
  }

  getWebserviceSD() {
    let URL = cmsApi + '/getSD'
    let body = {}
    return this.http.post(URL, body)
  }

  getWebserviceExpectedReturn() {
    let URL = cmsApi + '/getExpected'
    let body = {}
    return this.http.post(URL, body)
  }

  getWebserviceDrawDown() {
    let URL = cmsApi + '/getDrawDown'
    let body = {}
    return this.http.post(URL, body)
  }

  getWebserviceInvestAlloName() {
    let URL = cmsApi + '/getInvestMent_Allo_name'
    let body = {}
    return this.http.post(URL, body)
  }

  getWebserviceInvestmentAllo() {
    let URL = cmsApi + '/getInvestMent_Allo'
    let body = {}
    return this.http.post(URL, body)
  }

  getInvestmentMapp(fundtypeId) {
    let URL = cmsApi + '/getInvestMent_mapping'
    let body = { fundType_id: fundtypeId }
    // console.log("getInvestmentMapp ", body);
    
    return this.http.post(URL, body)
  }



}
